import React from 'react';
import { compose } from 'recompose';
import { HTMLTrans, TransLink } from '../Common/Translations';
import config from '../../config';
import Carousel from '../OwlCarousel/Carousel';
import { withResizeHelper } from '../Common/ResizeHelper';

const Card = (props) => {
  const { category = {} } = props;
  return (
    <div className="card h-100">
      <div className="p-3">
        {category.img &&
          <TransLink url={category.url}>
            <img className="img-fluid lazyload" data-src={config.s3BucketUrl + category.img} width="261" height="261" alt={category.name} />
          </TransLink>}
      </div>
      <div className="px-3 pb-3">
        <h5 className="ProximaNova-Bold mb-2">{category.name}</h5>
      </div>
    </div>
  );
};

const CategoryCarousel = (props) => {
  const owlOptions = {
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    center: true,
    dots: true,
    dotsClass: 'owl-dots pt-4',
    dotClass: 'owl-dot owl-landing-page-dot',
    items: 6,
    loop: true,
    margin: 10,
    mouseDrag: true,
    nav: true,
    stageOuterClass: 'owl-stage-outer',
    navContainerClass: 'owl-custom-nav',
    navElement: 'button',
    navClass: [
      'owl-custom-prev ml-4 rounded-circle btn btn-light',
      'owl-custom-next mr-4 rounded-circle btn btn-light'
    ],
    navText: [
      '<i class="fa fa-2x fa-angle-left"></i>',
      '<i class="fa fa-2x fa-angle-right"></i>'
    ],
    responsive: {
      0: {
        items: 2,
      },
      300: {
        items: 6,
      }
    },
    slideBy: 1,
  };

  return (
    <Carousel id='category-carousel' options={owlOptions}>
      {
        props.categories.map((categoryData, index) => {
          const category = { name: '', img: '', url: '' };
          const categoryDetails = categoryData.split('|');
          categoryDetails.forEach((elem, i) => {
            category[Object.keys(category)[i]] = elem;
          });
          if (category.name || category.img) {
            return (
              <Card key={`category-card-${category.name}`} category={category} />
            );
          }
          return '';
        })
      }
    </Carousel>
  );
};

const CategoryRow = (props) => {
  return (
    <div className='container d-flex flex-nowrap' style={{ overflowX: 'scroll'}}>
      {
        props.categories.map((categoryData) => {
          const category = { name: '', img: '', url: '' };
          const categoryDetails = categoryData.split('|');
          categoryDetails.forEach((elem, i) => {
            category[Object.keys(category)[i]] = elem;
          });
          if (category.name || category.img) {
            return (
              <div className='col-6 px-2'>
                <Card key={`category-card-${category.name}`} category={category} />
              </div>
            );
          }
          return '';
        })
      }
    </div>
  );
};

const ShopByCategory = (props) => {
  const { isMobile, t } = props;
  const categoryData = `${t('landing_page.shopbycategory')}`;
  const categories = categoryData ? categoryData.split('\n') : null;

  return (
    <div id="shopbycategory" className="py-5 bg-primary-lighten-2 content-visibility-auto"
      style={{ backgroundColor: `${t('landing_page.shopbycategory_background_color', '')}` }}>
      <div className="row my-2">
        <div className="col-12 text-center">
          <h2 className="ProximaNova-Bold landing-h4 mb-2">
            <HTMLTrans id="landing_page.shopbycategory_title">Shop By Category</HTMLTrans>
          </h2>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-12 mb-3">
          <div className="tab-content text-center">
            <div className='tab-pane fade show active' role="tabpanel">
              <div className="row px-2 justify-content-center">
                { categories == null || (isMobile ?
                  <CategoryRow categories={categories}/> :
                  <CategoryCarousel categories={categories}/>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const enhance = compose(
  withResizeHelper
);
export default enhance(ShopByCategory);
export const undecorated = ShopByCategory;



// WEBPACK FOOTER //
// ./src/LandingPage/ShopByCategory.js